import { HomeScreen } from '@/screens/home-screen/HomeScreen'

export default function () {
  return <HomeScreen />
}
